import { createFeatureSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';

export const selectBlockState = createFeatureSelector<BlockState>('blockState');